<template>
  <div class="navBox">
    <div class="box-list">
      <ul class="research_list">
        <!-- <router-link to="/home"></router-link> -->
        <li @click="onloadList('/home')">
          <img src="@/assets/image/home2.png" />
          <div class="research_tit">
            <h3 class="list_name">技术指标可视化</h3>
          </div>
        </li>
      </ul>
      <ul class="research_list">
        <!-- <router-link to="/factorAnalysisNav"> </router-link> -->
        <li @click="onloadList('/factorAnalysis/singlefactor')">
          <img src="@/assets/image/home3.png" />
          <div class="research_tit">
            <h3 class="list_name">因子分析</h3>
          </div>
        </li>
      </ul>
      <ul class="research_list" style="margin-right: 0;">
        <!-- <router-link  to="/experimentNav"></router-link> -->
        <li @click="onloadList('/experimentNav')">
          <img src="@/assets/image/home1.png" />
          <div class="research_tit">
            <h3 class="list_name">金融市场整体策略实验</h3>
          </div>
        </li>
      </ul>
      <div style="margin-top: 40px;">
        <span class="iosplay" @click="playfun">
          <i class="el-icon-video-play "></i>项目简介
        </span>
      </div>
    </div>
    <template v-if="videoType">
       <el-dialog
      class="dialog"
      top="5vh"
      :visible.sync="videoType"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%">
      <!-- <h3 slot="title">项目简介</h3> -->
      <div class="answer">
        <video :src="urlList" controls="controls" autoplay="autoplay" style="width: 100%; height: 100%;"></video>
      </div>
    </el-dialog>
    </template>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlList: process.env.VUE_APP_HUBEI + "/static/video/ProjectDescription.mp4",
      videoType:false,
      listData: [],
    };
  },
  methods: {
    playfun(){
      this.videoType = true;
    },
    onloadList(item) {
      this.$router.push({
        path: "/popup",
        query: {
          url: item,
        },
      });
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
.box-list {
  background: url("../assets/image/banner/0.png") no-repeat center;
  min-height: 100%;
  background-size: 100% 100%;
}
.box-list {
  padding: 24px 0 0 24px;
  margin: 0 auto;
  text-align: center;
  .research_list {
    display: inline-block;
    margin: 0 15px;
    cursor: pointer;
    position: relative;
    color: #fff;
    margin-bottom: 20px;
    margin-top: 100px;
    width: 416px;
    height: 387px;
    margin-right: 95px;
    transition: all 1s;
    img {
      height: 388px;
      border-radius: 10px;
    }
  }
  .research_list:hover {
    transform: scale(1.2);
  }
  .research_list:last-child {
    margin-right: 0;
  }
  .research_tit {
    position: absolute;
    bottom: 0;
    width: 416px;
    height: 89px;
    text-align: center;
    line-height: 66px;
    .list_name {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .list_desc {
      width: 130px;
      margin: 0 auto;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.boxBg {
  width: 330px;
  height: 395px;
  // background: url("../../assets/image/research1.png");
}
.iosplay{
  cursor: pointer;
      display: inline-block;
    width: 252px;
    height: 54px;
    line-height: 54px;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.25);
    border-radius: 30px;
    i{
      color: #57EFE0;
    font-size: 46px;
    padding-top: 5px;
    margin-right: 10px;
    vertical-align: -9px;
    }
}
.dialog /deep/.el-dialog__body{
  padding-top: 0;
}
.dialog /deep/.el-dialog__headerbtn{
      top: 8px;
}
</style>